// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto+Mono);"]);
// Module
exports.push([module.id, "body {\n  height: 100vh;\n  min-height: 100vh;\n}\n\n#root {\n  height: 100%;\n  min-height: 100%;\n  overflow-y: auto !important;\n}\n", ""]);
// Exports
module.exports = exports;
